import React, { createContext } from 'react';

const Residence_Context = createContext();

export default Residence_Context;